export default __webpack_public_path__ + "static/media/Icon.77946a6a.svg";